import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthConfigDto, SocialLoginConnectionDto } from '@gucci/shared-auth/types-auth';
import { Observable, ReplaySubject } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly authConfig$: ReplaySubject<AuthConfigDto> = new ReplaySubject(1);

  constructor(private readonly httpClient: HttpClient) {}

  captchaSiteKey$ = this.authConfig$.pipe(
    take(1),
    map((config) => config.captchaSiteKey)
  );

  captchaV2SiteKey$ = this.authConfig$.pipe(
    take(1),
    map((config) => config.captchaV2SiteKey)
  );

  captchaSkipCheck$ = this.authConfig$.pipe(
    take(1),
    map((config) => config.captchaSkipCheck)
  );

  public getConfig(): Observable<AuthConfigDto> {
    return this.authConfig$.pipe(take(1));
  }

  public getConnections(): Observable<SocialLoginConnectionDto[]> {
    return this.getConfig().pipe(map((config) => config.connections || []));
  }

  sync(): Observable<AuthConfigDto> {
    return this.httpClient
      .get<AuthConfigDto>(`${document.location.origin}/auth/proxy/config`, {
        headers: { 'Content-Type': 'application/json' },
      })
      .pipe(
        tap((config) => {
          config.connections = config.connections.map((con) => {
            if (!con.url.match('^https?://')) {
              return { ...con, url: `${document.location.origin}${con.url}` };
            }
            return con;
          });
          this.authConfig$.next(config);
        })
      );
  }
}
